export function handleScrollToBottom<ElementType extends HTMLElement>(
  event: React.UIEvent<ElementType>,
  onReachedBottom: () => void,
): void {
  const node = event.currentTarget;
  const position = node.scrollTop + node.clientHeight;
  if (node.scrollHeight - position <= 1) {
    onReachedBottom();
  }
}
